function postToc() {
  document.addEventListener("DOMContentLoaded", () => {
    const article = document.getElementById("post-article");
    const tocList = document.getElementById("post-toc-list");
    const tocListMobile = document.getElementById("post-toc-list-mobile");

    if (article && tocList && tocListMobile) {
      // Select all headings (e.g., h2, h3) inside the article
      const headings = article.querySelectorAll("h2, h3");

      headings.forEach((heading, index) => {
        // Create a unique ID for each heading if it doesn't already have one
        const id = heading.id || `heading-${index}`;
        heading.id = id;

        // Create a TOC item
        const li = document.createElement("li");
        li.className = heading.tagName.toLowerCase() === "h2" ? "toc-item toc-item-h2" : "toc-item toc-item-h3";
        const a = document.createElement("a");
        a.href = `#${id}`;
        a.textContent = heading.textContent;

        // Add click event to set active class
        a.addEventListener("click", (event) => {
          event.preventDefault(); // Prevent default anchor behavior

          // Get the target element
          const targetElement = document.getElementById(id);

          // Calculate the scroll position with an offset
          const offset = 90; // Adjust this value for your desired offset
          const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - offset;

          // Smoothly scroll to the calculated position
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        });

        li.appendChild(a);
        tocList.appendChild(li);
        const liClone = li.cloneNode(true);
        tocListMobile.appendChild(liClone);
      });

      // Highlight the active TOC item on scroll
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const tocLink = tocList.querySelector(`a[href="#${entry.target.id}"]`);
            if (entry.isIntersecting) {
              tocList.querySelectorAll("a").forEach((link) => link.classList.remove("active"));
              if (tocLink) tocLink.classList.add("active");
            }
          });
        },
        {
          rootMargin: "-90px 0px 0px 0px", // Adjust top margin to match the scroll offset (80px)
          threshold: 0, // Trigger when any part of the element is visible
        }
      );

      headings.forEach((heading) => observer.observe(heading));
    }
  });
}